import type { ChannelParams } from "containers/TermFormContainer";

export type ChannelFormulas = {
    defaultRow?: ChannelParams;
    overrides: ChannelParams[];
};

export const groupChannelFormulas = (rows: ChannelParams[]): Map<number, ChannelFormulas> => {
    const byChannelId = new Map<number, ChannelFormulas>();
    for (const row of rows) {
        const existing = byChannelId.get(row.channelId) ?? { overrides: [] };
        if (row.formatTypeId == null) existing.defaultRow = row;
        else existing.overrides.push(row);
        byChannelId.set(row.channelId, existing);
    }
    return byChannelId;
};

/** One row per format type — synced groups store the same override on every channel. */
export const uniqueFormatOverrides = (rows: ChannelParams[]): ChannelParams[] => {
    const byFormatTypeId = new Map<number, ChannelParams>();
    for (const row of rows) {
        if (row.formatTypeId == null || byFormatTypeId.has(row.formatTypeId)) continue;
        byFormatTypeId.set(row.formatTypeId, row);
    }
    return [...byFormatTypeId.values()];
};

export const formatTypeRecapLabel = (
    formatTypeId: number | null | undefined,
    namesById: ReadonlyMap<number, string>,
): string => {
    if (formatTypeId == null) return "";
    return namesById.get(formatTypeId) ?? String(formatTypeId);
};
